<template>
  <v-row>
    <v-col cols="12" class="pt-0">
      <gg-card-title>
        Notifications
      </gg-card-title>
    </v-col>
    <v-col cols="12">
      <gg-card>
        <gg-card-header>
          Notifications
          <dismiss-all
            v-if="notificationsCount > 0"
            class="float-right"
            location="history"
            @update="update"
          />
        </gg-card-header>
        <gg-card-text>
          <v-data-table :headers="headers" :items="notifications" :loading="loading">
            <template v-slot:item.title="{ item }">
              <a href="#" v-if="item.hasLink" @click.prevent="visitNotification(item.id)">
                {{ item.title }}
              </a>
              <span v-else>{{ item.title }}</span>
            </template>
            <template v-slot:item.description="{ item }">
              <div class="d-block table-description-text">
                {{ item.description }}
              </div>
            </template>
            <template v-slot:item.status="{ item }">
              <v-icon color="red" v-if="isItemNew(item)" class="pr-1">
                mdi-circle
              </v-icon>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn v-if="isItemNew(item)" text @click="dismissNotification(item.id)">
                Dismiss
              </v-btn>
            </template>
          </v-data-table>
        </gg-card-text>
      </gg-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { openNotification } from '@/helpers/notifications'
import DismissAll from '@/components/General/Header/Notifications/DismissAll'

export default {
  name: 'NotificationsHistoryView',
  components: {
    DismissAll
  },
  data: () => ({
    loading: true,
    headers: [
      {
        text: 'Type',
        value: 'title',
      },
      {
        text: 'Description',
        value: 'description',
      },
      {
        text: 'Date',
        value: 'created_at',
      },
      {
        text: 'Status',
        value: 'status',
        align: 'center'
      },
      {
        text: 'Actions',
        value: 'actions'
      }
    ],
  }),
  mounted () {
    this.update()
  },
  computed: {
    ...mapGetters({
      notifications: 'notifications/history',
      notificationsCount: 'notifications/notificationsCount'
    })
  },
  methods: {
    ...mapActions({
      dismiss: 'notifications/notificationDismiss',
      getUrl: 'notifications/notificationVisit',
      updateAll: 'notifications/updateAll',
      reportError: 'reportError'
    }),
    async dismissNotification (id) {
      try {
        await this.dismiss(id)
        await this.update()
      } catch (e) {
        this.reportError(e)
      }
    },
    async visitNotification (id) {
      try {
        const url = await this.getUrl(id)
        openNotification(url)
        await this.update()
      } catch (e) {
        this.reportError(e)
      }
    },
    async update () {
      try {
        this.loading = true
        await this.updateAll()
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    },
    isItemNew (item) {
      return item.dismissed_at === ''
    }
  }
}
</script>

<style scoped lang="scss">
  .table-description-text {
    overflow-wrap: break-word;
    white-space: normal;
  }
</style>
